import React, { useState, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "./Slider.scss";
import BusinessContext from "context/BusinessContext";

const Slider = ({ slider, products }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const { product, setProduct } = useContext(BusinessContext);
  const onClickHandlerSlider = (id) => {
    products.map((value) => {
      return value.id == id ? setProduct(value) : "";
    });
  };
  let loop;
  if (slider.length < 4) loop = false;
  else loop = true;
  return (
    <>
      <div className="Mshadow d-none d-md-block col-md-6"></div>
      <div className="row slider card col-11">
        <div className="col-12 col-md-8 col-xxl-7 slide1">
          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            loop={loop}
            spaceBetween={10}
            navigation={true}
            allowTouchMove={true}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[FreeMode, Navigation, Thumbs]}
            className="mySwiper2"
          >
            {slider.map((value, index) => {
              return (
                <SwiperSlide key={index}>
                  <div
                    className="slideContent"
                    onClick={(e) => onClickHandlerSlider(value.id)}
                    data-bs-toggle="modal"
                    data-bs-target="#SingleProduct"
                  >
                    <div className="image">
                      <img src={value.coverImg} alt="image" />
                    </div>
                    <div className="content">
                      <div className="name">{value.title}</div>
                      <div
                        className="text"
                        dangerouslySetInnerHTML={{ __html: value.description }}
                      ></div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        {/* <div className="d-none d-lg-block d-lg-1"></div> */}
        <div className="d-none d-sm-block col-md-3 col-xxl-2 slide2">
          <Swiper
            onSwiper={setThumbsSwiper}
            loop={loop}
            // autoplay={{ delay: 1000 }}
            // spaceBetween={10}
            // slidesPerView={3}
            allowTouchMove={true}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs]}
            breakpoints={{
              slidesPerView: 1,
              spaceBetween: 10,
              direction: "horizortal",
              480: {
                slidesPerView: 2,
              },
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
                direction: "vertical",
              },
            }}
            // direction={"vertical"}
            className="mySwiper"
          >
            {slider.map((value, index) => {
              return (
                <SwiperSlide key={index}>
                  <img src={value.coverImg} alt="image" />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Slider;
